import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getAgentcontactList, GetResAgentByID, GetResAgentList } from '../../Services/Service';
import ReservationSidebar from '../Commun/ReservationSidebar';
import ReservationHeader from '../Commun/ReservationHeader';
import { useProperty } from '../../PropertyContext';
import '../Booking Details/BookingList.css';
import './AgentList.css';
import { deleteReservationAgent } from '../../Redux/Slices/Reservation/deleteslice';

const ReservationAgentlist = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedProperty } = useProperty();
    const dispatch = useDispatch();
    const deleting = useSelector((state) => state.reservationDelete.deleting);
    const propertyID = selectedProperty?.PropertyID;
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [agentList, setAgentList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [selectedLoginID, setSelectedLoginID] = useState(null);



    useEffect(() => {
        if (location.state?.success) {
            setSuccessMessage(location.state.success);
            setShowSuccess(true);


            setTimeout(() => setShowSuccess(false), 4000);
        }
    }, [location.state]);


    const getAgentsList = useCallback(async () => {
            setLoading(true);
            try {
                const result = await GetResAgentList(propertyID);
                if (Array.isArray(result)) {
                    setAgentList(result);
                }
            }
            catch (error) {
                console.log("error getting agent list", error);
            } finally {
                setLoading(false);
            }
    }, [propertyID]);

    useEffect(() => {
        getAgentsList();
    }, [getAgentsList]);



    // inside ReservationAgentlist component
    const handleEditClick = async (agentID) => {
        setLoading(true);
        try {
            const data = await GetResAgentByID(agentID, selectedProperty?.PropertyID);
            if (!data) {
                alert("Agent data not found");
                return;
            }
            navigate('/Reservation/NewAgent', { state: { agentData: data } });
        } catch (err) {
            console.error("Error fetching agent by id", err);
        } finally {
            setLoading(false);
        }
    };




    // useEffect(() => {
    //     const $ = window.$;
    //     if (agentList.length > 0 && $ && $.fn.dataTable) {
    //         const table = $('.basic-datatables').DataTable();
    //         if (table) {
    //             table.destroy();
    //         }
    //         setTimeout(() => {
    //             $('.basic-datatables').DataTable();
    //         }, 0);
    //     }
    // }, [agentList]);

    // Contact List API Call
    const handleOpenContactList = async (loginID) => {
        setSelectedLoginID(loginID);
        setLoading(true);
        try {
            const contactResult = await getAgentcontactList(loginID);
            console.log("Contact List Response:", contactResult);
            setContactList(contactResult?.Table || []);
        } catch (error) {
            console.error("Error fetching contact list:", error);
            setContactList([]);
        } finally {
            setLoading(false);
        }
    };



    // const handleNewContactClick = () => {
    //     const modal = document.getElementById('example-modal-lg');
    //     const instance = window.bootstrap.Modal.getInstance(modal);
    //     instance?.hide();

    //     navigate('/Property/RateUpdateForm');
    // };


    const handleNewContactClick = () => {
        const modal = document.getElementById('example-modal-lg');
        const instance = window.bootstrap.Modal.getInstance(modal);
        instance?.hide();

        if (selectedLoginID) {
            const propertyID = localStorage.getItem("PropertyID");
            navigate(`/Property/RateUpdateForm?R=TA-${selectedLoginID}&PropertyID=${propertyID}`);
        } else {
            alert("No Agent Selected");
        }
    };

    const handleDeleteClick = async (agentID) => {
        const shouldDelete = await swal({ title: "Are you sure?", text: "Once deleted, this agent cannot be recovered.", icon: "warning", buttons: ["Cancel", "Delete"], dangerMode: true });
        if (!shouldDelete) return;
        try {
            const { response } = await dispatch(deleteReservationAgent({ AgentID: agentID, PropID: propertyID })).unwrap();
            await getAgentsList();
            await swal(response?.Message || response?.message || "Agent deleted successfully.", { icon: "success" });
        } catch (error) {
            await swal(error?.Message || error?.message || "Unable to delete agent.", { icon: "error" });
        }
    };

    const formattedAgentData = agentList?.map(item => ({
        ...item,
        FullName: `${item.FirstName || ""} ${item.MidlleName || ""} ${item.LastName || ""}`.trim(),
        Phone: item.MobileNo || ""
    }));


    return (
        <>

            {(loading || deleting) && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>{successMessage}</div>
                                        </div>
                                    )}

                                    <div className="card booking-list-card agent-list-card">
                                        <div className="card-header booking-list-header">
                                            <h4 className="card-title mb-0">Agent List</h4>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive booking-list-table-wrap agent-list-table-wrap">
                                                {/* <table id="agentTable"
                                                    // id="basic-datatables"
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>TA</th>
                                                            <th>City</th>
                                                            <th>Contact Person Name</th>
                                                            <th>Phone</th>
                                                            <th>Opera Link </th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {agentList.map((agent, index) => (
                                                            <tr key={agent.AgentID || index}>


                                                                <td>{agent.TA_Name || 'N/A'}</td>
                                                                <td>{agent.City || 'N/A'}</td>
                                                                <td>{`${agent.FirstName || ''} ${agent.MidlleName || ''} ${agent.LastName || ''}`.trim() || 'N/A'}</td>

                                                                <td>{agent.MobileNo || 'N/A'}</td>

                                                                <td>{agent.OperaProfileID ? "Yes" : "No"}</td>

                                                                <td className="text-center">
                                                                    <div className="dropdown dropdown-action position-absolute" style={{ marginInline: "13px", marginTop: "-9px" }}>
                                                                        <a href="/" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <button className="dropdown-item" onClick={() => handleEditClick(agent.AgentID)}> <i className="fas fa-edit me-2"></i>Edit </button>
                                                                            <button type="button" className=" dropdown-item" data-bs-toggle="modal" data-bs-target="#example-modal-lg" onClick={() => handleOpenContactList(agent.LoginID)}><i className="fas fa-user me-2"></i> Contact List</button>
                                                                            <button className="dropdown-item" type="button"> <i className="fas fa-trash me-2"></i>Delete </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table> */}

                                                <DataTable
                                                    value={formattedAgentData}
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                    stripedRows
                                                    showGridlines
                                                    responsiveLayout="scroll"
                                                    filterDisplay="row"
                                                    className="p-datatable-bordered agent-list-table"
                                                    emptyMessage={
                                                        <div style={{ textAlign: "center", width: "100%" }}>
                                                            No Agent found.
                                                        </div>
                                                    }
                                                >
                                                    <Column
                                                        field="TA_Name"
                                                        header="TA"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search TA"
                                                        body={(rowData) => rowData.TA_Name || "N/A"}
                                                    />

                                                    <Column
                                                        field="City"
                                                        header="City"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search City"
                                                        body={(rowData) => rowData.City || "N/A"}
                                                    />

                                                    <Column
                                                        field="FullName"
                                                        header="Contact Person Name"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Name"
                                                        body={(rowData) => rowData.FullName || "N/A"}
                                                    />

                                                    <Column
                                                        field="Phone"
                                                        header="Phone"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Phone"
                                                        body={(rowData) => rowData.Phone || "N/A"}
                                                    />

                                                    <Column
                                                        header="Opera Link"
                                                        body={(rowData) => (rowData.OperaProfileID ? "Yes" : "No")}
                                                    />

                                                    <Column
                                                        header="Action"
                                                        body={(rowData) => (
                                                            <div className="text-center">
                                                                <div className="dropdown dropdown-action">
                                                                    <button
                                                                        type="button"
                                                                        className="action-icon"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                    </button>

                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleEditClick(rowData.AgentID)}
                                                                        >
                                                                            <i className="fas fa-edit me-2"></i>
                                                                            Edit
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#example-modal-lg"
                                                                            onClick={() => handleOpenContactList(rowData.LoginID)}
                                                                        >
                                                                            <i className="fas fa-user me-2"></i>
                                                                            Contact List
                                                                        </button>

                                                                        <button className="dropdown-item" type="button" onClick={() => handleDeleteClick(rowData.AgentID)} disabled={deleting}>
                                                                            <i className="fas fa-trash me-2"></i>
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        {/*  Modal */}
                        <div
                            className="modal fade"
                            id="example-modal-lg"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myLargeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            contact list
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive">

                                            <div className='text-end mb-3'>
                                                <button className='btn btn-sm btn-black' onClick={handleNewContactClick}> New Contact  </button>
                                            </div>
                                            <table className="table table-bordered table-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Contact On</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {contactList.length > 0 ? (
                                                        contactList.map((contact, index) => (
                                                            <tr key={index}>
                                                                <td>{contact.StartDate || "N/A"}</td>
                                                                <td>{contact.EndDate || "N/A"}</td>
                                                                <td>{contact.CreatedDate || "N/A"}</td>
                                                                <td className='text-center'>
                                                                    <button className="btn btn-sm btn-dark py-1 px-2"><i className='fas fa-edit'></i></button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">No Contact Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Modal */}
                    </>
                </div>

            </div>
        </>
    );
};

export default ReservationAgentlist;
